export enum PermissionsPinesCea {
  gestion = 6002,
  deposito = 6001,
  venta_pines = 6003,
  recaudo = 6004,
  pago_giro = 6005,
  pin_pago = 6006,
  operarPinesVus= 53,
  administrarPinesVus= 63  
}
